import { Component, OnInit, NgModule } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as _moment from 'moment';
import {map} from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import {AppComponent} from '../../app.component';
import { AlertService } from '../../alertpopup/_alert';
import { Contactdetail } from './contactdetail';
@Component({
    selector: 'app-add-contact',
    templateUrl: './add-contact.component.html',
    styleUrls: ['./add-contact.component.css'],
    standalone: false
})
export class AddContactComponent implements OnInit {
  ContactType: any;
  url: string;
  addContactEvent: FormGroup;
  id: any;
  numb: any;
  Department1: any;
  Designation: any;
  pageurl: string;
  ADDContactDesignationType: string;
  ADDContactDepartmentType: string;
  RightsID: string;
  RouteGMDesignation: string;
  RouteGMDepartment: string;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
};
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, private sanitization: DomSanitizer, protected alertService: AlertService ) {
    this.url = AppComponent.baseURL;
   }

  ngOnInit() {
    this.RightsID = localStorage.getItem('UserRight');
    if (this.RightsID.includes('202034001') || this.RightsID.includes('202034021') || this.RightsID.includes('202034000')) {
    } else {
      window.location.href = "module/0";
    }
    this.fetchRouteDataRights();
    this.getContactType();
    this.ADDContactDesignationType = "Hidden";
    this.ADDContactDepartmentType = "Hidden";
    this.pageurl = this.router.url;
    let pagehead = this.pageurl.split('/');
    this.id = pagehead[2];
    // Set Validation On Contact Form
    this.addContactEvent = this.formBuilder.group({
      ContactDesignation: [null, Validators.required],ContactType:['',Validators.required], ContactDepartment: ['', Validators.required], ContactTitle: ['',Validators.required], ContactName: ['', Validators.required], ContactCustomerCode: ['',Validators.required],
      ContactMobile: ['', Validators.required], ContactPhone: ['', Validators.required], ContactEmail: ['', [ Validators.required, Validators.email]], ADDContactDesignation: [''], ADDContactDepartment: [''] });
    // Set By Default Value on Header Part
    this.addContactEvent.patchValue({
     ContactType:"1",
      ContactDesignation: null, ContactDepartment: null, ContactTitle: null });
    this.getMaster('035', '') .subscribe( (data: any) => {
        this.Designation = data; });
    this.getMaster('030', '') .subscribe( (data: any) => {
          this.Department1 = data; });
  }

  get f () { return this.addContactEvent.controls; }
  fetchRouteDataRights() {
    // tslint:disable-next-line: max-line-length
    if (this.RightsID.includes('202042000') || this.RightsID.includes('202042001') || this.RightsID.includes('202042021')) {
     this.RouteGMDepartment = "general-master/030";
     this.RouteGMDesignation = "general-master/035";
    } else {
    this.RouteGMDepartment = "module/0";
    this.RouteGMDesignation = "module/0"; }
    }
    getContactType(){
      this.http.get(this.url + 'Notice/GetContactType')
      .subscribe( (data) => {
        this.ContactType = JSON.parse(data.toString()); });
        console.log(this.ContactType);
      }
  getMaster(GID: string, MID: string) {
    return this.http.get(this.url + 'GM/GetMaster?GenID=' + GID + '&MainID=' + MID)
    .pipe(map(data => data = (data == null ? null : JSON.parse(data.toString()))));
    }
    onContactDesignationSelect(SelectedID) {
    if (SelectedID == "-1" || SelectedID.MainDescr == "Other") { this.ADDContactDesignationType = "Text"; } else { this.ADDContactDesignationType = "Hidden"; }
  }
  onContactDepartmentSelect(selectedControlID) {
    if (selectedControlID == "-1" ) { this.ADDContactDepartmentType = "Text"; } else { this.ADDContactDepartmentType = "Hidden"; }
  }

// Save Fact Sheet Data
onContactSubmit(ContactDetailData) {
  if (this.addContactEvent.invalid) {
    this.addContactEvent.markAllAsTouched();
    return;
  }
  if (ContactDetailData.ContactDesignation == "-1" && ContactDetailData.ADDContactDesignation == "") {
    this.alertService.showWarning("Please Enter Other Designation");
     return;
   }
  if (ContactDetailData.ContactDepartment == "-1" && ContactDetailData.ADDContactDepartment == "") {
     this.alertService.showWarning("Please Enter Other Department");
     return;
   }
  if (ContactDetailData.ContactName == "") {
    this.alertService.showWarning("Add Contact Name");
  } else {
    this.numb = 1;
    let ContactDetailInsert: Contactdetail = {
      ContactTypeID: ContactDetailData.ContactType,
      DesignationID: ContactDetailData.ContactDesignation,
      DesignationName: ContactDetailData.ADDContactDesignation,
      DepartmentID: ContactDetailData.ContactDepartment,
      DepartmentName: ContactDetailData.ADDContactDepartment,
      Title: ContactDetailData.ContactTitle,
      Name: ContactDetailData.ContactName,
      CustomerCode: ContactDetailData.ContactCustomerCode,
      Mobile: ContactDetailData.ContactMobile,
      ContactNo: ContactDetailData.ContactPhone,
      Email: ContactDetailData.ContactEmail,
      recEnable: this.numb,
      recUser: this.numb,
      recAddUser: this.numb,
      NoticeID: this.id
    };
    this.http.post(this.url + 'Notice/insertUpdateContact', ContactDetailInsert) .subscribe( (data) => {
            if (data == null) {
              this.alertService.showError("Contact Not Added");
            } else {
              this.alertService.showSuccess("Contact Added Successfully");
              if (ContactDetailData.ContactDesignation == "-1") {
                this.getMaster('035', '') .subscribe( (data: any) => {
                  this.Designation = data; });
              }
              if (ContactDetailData.ContactDepartment == "-1") {
                this.getMaster('030', '') .subscribe( ( data: any) => {
                  this.Department1 = data; });
              }
              // this.addContactEvent.patchValue({
              //   ContactDesignation: null, ContactDepartment: null, ContactTitle: null, ContactName: null,
              //   ContactCustomerCode: null, ContactEmail: null, ContactPhone: null, ContactMobile: null
              // });
              this.addContactEvent.reset();
            }
           }
         );
  }

}
}
